import { Container, Box, Stack } from "@mui/material";

type Props = {
  children: React.ReactNode;
  maxWidth?: "xs" | "sm" | "md" | "lg" | "xl";
  sx?: any;
  beforeContent?: React.ReactNode;
};

export default function BigContainer({
  children,
  maxWidth = "xl",
  sx = {},
  beforeContent,
}: Props) {
  return (
    <Stack direction={"column"} sx={{ width: "100%" }}>
      {beforeContent}
      <Container
        maxWidth={maxWidth}
        sx={{
          py: 4,
          px: { xs: 2, sm: 3, md: 4 },
          ...sx,
        }}
      >
        <>{children}</>
      </Container>
    </Stack>
  );
}
